var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[(_vm.user.role === 'admin')?_c('AdminHome'):_c('CustomerHome')],1)}
var staticRenderFns = []

export { render, staticRenderFns }